import { render, staticRenderFns } from "./OtpSetup.vue?vue&type=template&id=7c11a024&scoped=true"
import script from "./OtpSetup.vue?vue&type=script&lang=js"
export * from "./OtpSetup.vue?vue&type=script&lang=js"
import style0 from "./OtpSetup.vue?vue&type=style&index=0&id=7c11a024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c11a024",
  null
  
)

export default component.exports